import type { GraphNode, GraphEdge } from '../graph/nodeDefs.js';

function nodeTypeLabel(nodes: GraphNode[], nodeId: string | null): string {
  if (!nodeId) return '?';
  return nodes.find(node => node.id === nodeId)?.type ?? nodeId;
}

function connectionLabel(nodes: GraphNode[], fromNodeId: string | null, toNodeId: string | null): string {
  return `${nodeTypeLabel(nodes, fromNodeId)} -> ${nodeTypeLabel(nodes, toNodeId)}`;
}

export function addNodeLabel(type: string): string {
  return `Add node: ${type}`;
}

export function deleteNodeLabel(typeOrId: string): string {
  return `Delete node: ${typeOrId}`;
}

export function editNodeFieldLabel(nodeType: string, field: string): string {
  return `Edit ${nodeType}: ${field}`;
}

export function connectNodesLabel(nodes: GraphNode[], fromNodeId: string | null, toNodeId: string | null): string {
  return `Connect nodes: ${connectionLabel(nodes, fromNodeId, toNodeId)}`;
}

export function reconnectNodesLabel(nodes: GraphNode[], fromNodeId: string | null, toNodeId: string | null): string {
  return `Reconnect nodes: ${connectionLabel(nodes, fromNodeId, toNodeId)}`;
}

export function disconnectNodesLabel(nodes: GraphNode[], fromNodeId: string | null, toNodeId: string | null): string {
  return `Disconnect nodes: ${connectionLabel(nodes, fromNodeId, toNodeId)}`;
}

export function cutConnectionsLabel(count: number): string {
  return `Cut ${count} connection${count === 1 ? '' : 's'}`;
}

export function moveNodeLabel(nodeType: string): string {
  return `Move node: ${nodeType}`;
}

export function adjustParamLabel(name: string): string {
  return `Adjust Param: ${name}`;
}

export function loadFromStorageLabel(): string {
  return 'Load from storage';
}

export function importFileLabel(): string {
  return 'Import file';
}

export function clearGraphLabel(): string {
  return 'Clear graph';
}

export function openTemplateLabel(name: string): string {
  return `Open template: ${name}`;
}

export function singleDisconnectedEdgeLabel(nodes: GraphNode[], edges: GraphEdge[]): string {
  const edge = edges[0];
  return disconnectNodesLabel(nodes, edge?.fromNode ?? null, edge?.toNode ?? null);
}
